import { useEffect, useState } from "react";
import { Text } from "@volca/ui/components/ui/text";
import { dayjs } from "@/core/utils/date";

interface RelativeTimeProps {
  timestamp: string;
  prefix?: string;
  className?: string;
}

export const RelativeTime = ({
  timestamp,
  prefix,
  className,
}: RelativeTimeProps) => {
  const [relativeTime, setRelativeTime] = useState("");

  useEffect(() => {
    const updateRelativeTime = () => {
      setRelativeTime(dayjs(timestamp).fromNow());
    };

    // Update immediately
    updateRelativeTime();

    // Update every minute
    const interval = setInterval(updateRelativeTime, 60000);

    return () => clearInterval(interval);
  }, [timestamp]);

  return (
    <Text variant="caption" tone="muted" className={className}>
      {prefix && `${prefix} `}
      {relativeTime}
    </Text>
  );
};
